<div
  class="tw-mb-2 menus-table tw-border dark:tw-border-dark-100 tw-px-0 tw-mt-4 tw-relative table-responsive"
>
  <table class="table table-head-custom table-vertical-center overflow-hidden">
    <thead class="tw-border-b dark:tw-border-dark-100">
      <tr class="fw-bold fs-6 tw-text-gray-800 dark:tw-text-gray-200 tw-h-[60px]">
        <th>
          <div class="row tw-flex flex-row">
            <!-- select all -->
            <div
              class="xl:tw-w-1/4 sm:tw-w-1/2 order-xl-1 order-sm-2 form-check tw-flex tw-justify-start tw-items-center tw-mt-2 tw-pr-[8px] ltr:tw-pl-[8px]"
            >
              <input
                id="selectAllMenus"
                type="checkbox"
                class="form-check-input tw-mr-0 tw-ml-2"
                (input)="onSelectAll($event)"
                [(ngModel)]="isSelectAll"
              />
              <label
                for="selectAllMenus"
                class="tw-font-medium tw-text-gray-800 dark:tw-text-gray-300"
                >{{ "common.selectAll" | translate }}</label
              >
            </div>

            <!-- search box  -->
            <div
              class="xl:tw-w-7/12 md:tw-w-full order-xl-2 order-sm-1 tw-flex tw-items-center sm:tw-mb-2 xl:tw-mb-0"
            >
              <div class="search-box tw-flex-center tw-w-full tw-relative">
                <!-- search input -->
                <input
                  #searchInput
                  [(ngModel)]="searchedText"
                  class="form-control tw-h-[40px]"
                  [placeholder]="'common.search' | translate"
                />
                <i
                  *ngIf="searchedText"
                  (click)="clearSearch()"
                  class="clear-search-icon mdi mdi-close text-danger mdi-24px"
                ></i>
              </div>
            </div>

            <!-- expand btns -->
            <div
              class="xl:tw-w-1/6 sm:tw-w-1/2 order-xl-3 order-sm-3 tw-flex tw-justify-end tw-items-center xl:tw-mt-0 sm:tw-mt-2"
            >
              <!-- expand-all -->
              <i
                class="mdi mdi-arrow-expand-all mdi-22px xl:tw-mx-3 sm:tw-mx-4 tw-cursor-pointer text-success"
                [matTooltip]="'common.expandAll' | translate"
                (click)="onExpandAll()"
              ></i>
              <!-- collapse-all -->
              <i
                class="mdi mdi-arrow-collapse-all mdi-24px tw-mx-1 tw-cursor-pointer text-gray"
                [matTooltip]="'common.collapseAll' | translate"
                (click)="onCollapseAll()"
              ></i>
            </div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let menu of menus; let i = index">
        <!-- level 1  -->
        <tr
          *ngIf="menu.isVisible"
          class="parent-menu"
          [id]="'menu-' + menu.id"
          [attr.data-id]="menu.id"
          [attr.data-parentId]="menu.parentId"
          [attr.data-level]="1"
          [class]="i == 0 ? 'row-active' : ''"
        >
          <td class="tw-flex border-bottom p-0">
            <!-- checkbox -->
            <div class="form-check tw-flex-center tw-mb-0">
              <input
                type="checkbox"
                class="form-check-input tw-ml-2"
                (input)="onSelect($event, menu)"
                [attr.data-checkbox-id]="menu.id"
              />
            </div>

            <div
              class="tw-flex tw-justify-between tw-items-center tw-mr-5 tw-my-1 tw-w-full"
            >
              <!-- title -->
              <div
                class="menu-title tw-text-right tw-w-full tw-cursor-pointer tw-py-3 tw-flex"
                (click)="onActiveMenu(menu.id)"
              >
                <span
                  class="svg-icon svg-icon-2 tw-ml-2"
                  [inlineSVG]="
                    '/assets/media/icons/duotune/asideMenu/' + menu?.icon
                  "
                >
                </span>

                <span class="tw-font-medium">
                  {{ menu.title }}
                </span>
              </div>

              <!-- openClose Menu Icon -->

              <i
                *ngIf="menu?.subMenus?.length > 0"
                class="mdi mdi-chevron-left mdi-24px text-gray tw-ml-3 tw-cursor-pointer toggle-menu-btn"
                (click)="showSubMenusToggle($event.target, menu.id)"
              ></i>
            </div>
          </td>
        </tr>

        <!-- level 2 -->
        <ng-container *ngIf="menu?.subMenus?.length > 0">
          <ng-container *ngFor="let menu2 of menu?.subMenus; let i = index">
            <tr
              *ngIf="menu2.isVisible"
              [id]="'menu-' + menu2.id"
              [attr.data-id]="menu2.id"
              [attr.data-parentId]="menu2.parentId"
              [attr.data-level]="2"
              class="d-none"
            >
              <td class="tw-flex border-bottom p-0">
                <!-- checkbox -->
                <div class="form-check tw-flex-center tw-mb-0">
                  <input
                    type="checkbox"
                    class="form-check-input tw-ml-2"
                    (input)="onSelect($event, menu2)"
                    [attr.data-checkbox-id]="menu2.id"
                  />
                </div>

                <div
                  class="tw-flex tw-justify-between tw-items-center tw-mr-[50px] ltr:tw-ml-[50px] tw-mb-0 tw-w-full"
                >
                  <!-- title -->
                  <div
                    class="menu-title tw-text-right tw-w-full tw-cursor-pointer tw-py-3"
                    (click)="onActiveMenu(menu2.id)"
                  >
                    <i class="mdi mdi-circle-medium tw-mx-1"></i>
                    <span class="tw-font-medium">
                      {{ menu2.title }}
                    </span>
                  </div>

                  <!-- openClose Menu Icon -->

                  <i
                    *ngIf="menu2?.subMenus?.length > 0"
                    class="mdi mdi-chevron-left mdi-24px text-gray tw-ml-3 tw-cursor-pointer toggle-menu-btn"
                    (click)="showSubMenusToggle($event.target, menu2.id)"
                  ></i>
                </div>
              </td>
            </tr>

            <!-- level 3 -->
            <ng-container *ngIf="menu2?.subMenus?.length > 0">
              <ng-container
                *ngFor="let menu3 of menu2?.subMenus; let i = index"
              >
                <tr
                  *ngIf="menu3.isVisible"
                  [id]="'menu-' + menu3.id"
                  [attr.data-id]="menu3.id"
                  [attr.data-parentId]="menu3.parentId"
                  [attr.data-level]="3"
                  class="d-none"
                >
                  <td class="tw-flex border-bottom p-0">
                    <!-- checkbox -->
                    <div class="form-check tw-flex-center tw-mb-0">
                      <input
                        type="checkbox"
                        class="form-check-input tw-ml-2"
                        (input)="onSelect($event, menu3)"
                        [attr.data-checkbox-id]="menu3.id"
                      />
                    </div>

                    <div
                      class="tw-flex tw-justify-between tw-items-center tw-mb-0 tw-w-full"
                      style="margin-right: 100px"
                    >
                      <!-- title -->
                      <div
                        class="menu-title tw-text-right tw-w-full tw-cursor-pointer tw-py-3"
                        (click)="onActiveMenu(menu3.id)"
                      >
                        <i class="mdi mdi-circle-medium tw-mx-1"></i>
                        <span class="tw-font-medium">
                          {{ menu3.title }}
                        </span>
                      </div>

                      <!-- openClose Menu Icon -->

                      <i
                        *ngIf="menu3?.subMenus?.length > 0"
                        class="mdi mdi-chevron-left mdi-24px text-gray tw-ml-3 tw-cursor-pointer toggle-menu-btn"
                        (click)="showSubMenusToggle($event.target, menu3.id)"
                      ></i>
                    </div>
                  </td>
                </tr>

                <!-- level 4 -->
                <ng-container *ngIf="menu3?.subMenus?.length > 0">
                  <ng-container
                    *ngFor="let menu4 of menu3?.subMenus; let i = index"
                  >
                    <tr
                      *ngIf="menu4.isVisible"
                      [id]="'menu-' + menu4.id"
                      [attr.data-id]="menu4.id"
                      [attr.data-parentId]="menu4.parentId"
                      [attr.data-level]="3"
                      class="d-none"
                    >
                      <td class="tw-flex border-bottom p-0">
                        <!-- checkbox -->
                        <div class="form-check tw-flex-center tw-mb-0 p-0">
                          <input
                            type="checkbox"
                            class="form-check-input tw-ml-2"
                            (input)="onSelect($event, menu4)"
                            [attr.data-checkbox-id]="menu4.id"
                          />
                        </div>

                        <div
                          class="tw-flex tw-justify-between tw-items-center tw-mb-0 tw-w-full"
                          style="margin-right: 100px"
                        >
                          <!-- title -->
                          <div
                            class="menu-title tw-text-right tw-w-full tw-cursor-pointer tw-py-3"
                            (click)="onActiveMenu(menu4.id)"
                          >
                            <i class="mdi mdi-circle-medium tw-mx-1"></i>
                            <span class="tw-font-medium">
                              {{ menu4.title }}
                            </span>
                          </div>

                          <!-- openClose Menu Icon -->

                          <i
                            *ngIf="menu4?.subMenus?.length > 0"
                            class="mdi mdi-chevron-left mdi-24px text-gray tw-ml-3 tw-cursor-pointer toggle-menu-btn"
                            (click)="
                              showSubMenusToggle($event.target, menu4.id)
                            "
                          ></i>
                        </div>
                      </td>
                    </tr>

                    <!-- level 5 -->
                    <ng-container *ngIf="menu4?.subMenus?.length > 0">
                      <ng-container
                        *ngFor="let menu5 of menu4?.subMenus; let i = index"
                      >
                        <tr
                          *ngIf="menu5.isVisible"
                          [id]="'menu-' + menu5.id"
                          [attr.data-id]="menu5.id"
                          [attr.data-parentId]="menu4.parentId"
                          [attr.data-level]="3"
                          class="d-none"
                        >
                          <td class="tw-flex border-bottom p-0">
                            <!-- checkbox -->
                            <div class="form-check tw-flex-center tw-mb-0">
                              <input
                                type="checkbox"
                                class="form-check-input tw-ml-2"
                                (input)="onSelect($event, menu5)"
                                [attr.data-checkbox-id]="menu5.id"
                              />
                            </div>

                            <div
                              class="tw-flex tw-justify-between tw-items-center tw-mb-0 tw-w-full"
                              style="margin-right: 100px"
                            >
                              <!-- title -->
                              <div
                                class="menu-title tw-text-right tw-w-full tw-cursor-pointer tw-py-3"
                                (click)="onActiveMenu(menu5.id)"
                              >
                                <i class="mdi mdi-circle-medium tw-mx-1"></i>
                                <span class="tw-font-medium">
                                  {{ menu5.title }}
                                </span>
                              </div>

                              <!-- openClose Menu Icon -->

                              <i
                                *ngIf="menu5?.subMenus?.length > 0"
                                class="mdi mdi-chevron-left mdi-24px text-gray tw-ml-3 tw-cursor-pointer toggle-menu-btn"
                                (click)="
                                  showSubMenusToggle($event.target, menu5.id)
                                "
                              ></i>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- empty -->
      <ng-container *ngIf="menus?.length == 0 || !isVisibleMenu()">
        <div
          class="tw-flex tw-justify-center tw-mt-[30px] tw-mb-[20px] tw-text-lg text-gray tw-font-medium"
        >
          {{ "common.empty" | translate }}
        </div>
      </ng-container>
    </tbody>
  </table>
</div>

<!-- count display -->
<div
  class="tw-flex tw-justify-start tw-items-center tw-mt-5 tw-mx-[9px] tw-pr-2 tw-py-3 role-footer bg-light border rounded"
>
  <!-- menusCount -->
  <div class="tw-ml-[30px] ltr:tw-mr-[30px]">
    <span class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-200 tw-mr-2">
      {{ "common.menusCount" | translate }} :
    </span>
    <span class="tw-text-[13px] badge badge-secondary">
      {{ menusCount }}
    </span>
  </div>

  <!-- menusSelectedCount -->
  <div>
    <span class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-200">
      {{ "common.selectedCount" | translate }} :
    </span>
    <span class="tw-text-[13px] badge badge-secondary">
      {{ selectedMenuIds?.length }}
    </span>
    <div></div>
  </div>
</div>
